export default "__VITE_ASSET__0V4V9WjC__"